import {Nav} from "rsuite";

const styles = {
    marginBottom: '1rem',
    marginRight: '0.5rem',
};

const SkillViewerNav = ({ active, onSelect, bucketedSkills, ...props }) => {
    return (
        <Nav {...props} vertical activeKey={active} onSelect={onSelect} style={styles}>
            {Object.keys(bucketedSkills).sort().map((skillType) => {
                return (
                    <Nav.Item key={skillType} eventKey={skillType}>{skillType}</Nav.Item>
                );
            })}
        </Nav>
    );
};

export default SkillViewerNav;